document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.bh-header');
  const drawer = document.querySelector('.bh-header__drawer');
  const toggle = document.querySelector('.bh-header__mobile-toggle');

  if (!header || !drawer || !toggle) return;

  let closeTimer = null;

  /* ===================================
     Sticky Header
  =================================== */

  function updateSticky() {
    if (!header.classList.contains('bh-header--sticky')) return;

    if (window.scrollY > 10) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  }

  updateSticky();

  window.addEventListener('scroll', updateSticky, {
    passive: true
  });

  /* ===================================
     Drawer Position
  =================================== */

  function updateDrawerPosition() {
    if (drawer.hidden) return;

    const headerRect = header.getBoundingClientRect();

    const drawerTop = Math.max(
      0,
      headerRect.bottom
    );

    drawer.style.setProperty(
      '--bh-drawer-top',
      `${drawerTop}px`
    );
  }

  /* ===================================
     Open Drawer
  =================================== */

  function openDrawer() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    const headerRect = header.getBoundingClientRect();

    drawer.style.setProperty(
      '--bh-drawer-top',
      `${Math.max(0, headerRect.bottom)}px`
    );

    drawer.hidden = false;

    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      document.body.classList.add('bh-menu-open');
    });

    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');

    document.body.style.overflow = 'hidden';
  }

  /* ===================================
     Close Drawer
  =================================== */

  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;

    drawer.classList.remove('is-open');

    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');

    document.body.classList.remove('bh-menu-open');
    document.body.style.overflow = '';

    closeTimer = window.setTimeout(() => {
      drawer.hidden = true;

      drawer.style.removeProperty(
        '--bh-drawer-top'
      );

      closeTimer = null;
    }, 300);
  }

  /* ===================================
     Mobile Toggle
  =================================== */

  toggle.addEventListener('click', () => {
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  /* ===================================
     Click Outside
  =================================== */

  drawer.addEventListener('click', event => {
    if (event.target === drawer) {
      closeDrawer();
    }
  });

  /* ===================================
     Escape
  =================================== */

  document.addEventListener('keydown', event => {
    if (
      event.key === 'Escape' &&
      drawer.classList.contains('is-open')
    ) {
      closeDrawer();

      toggle.focus();
    }
  });

  /* ===================================
     Window changes
  =================================== */

  window.addEventListener(
    'resize',
    () => {
      if (window.innerWidth > 990) {
        closeDrawer();
        return;
      }

      if (drawer.classList.contains('is-open')) {
        updateDrawerPosition();
      }
    },
    { passive: true }
  );

  window.addEventListener(
    'scroll',
    () => {
      if (drawer.classList.contains('is-open')) {
        updateDrawerPosition();
      }
    },
    { passive: true }
  );

  /* ===================================
     Mobile Accordion
  =================================== */

  const accordionButtons =
    drawer.querySelectorAll(
      '.bh-header__menu-button'
    );

  accordionButtons.forEach(button => {
    button.addEventListener(
      'click',
      event => {
        if (window.innerWidth > 990) return;

        const currentItem =
          button.closest(
            '.bh-header__menu-item'
          );

        if (!currentItem) return;

        const submenu =
          currentItem.querySelector(
            ':scope > .bh-header__submenu'
          );

        /*
          If this item has no submenu,
          allow the normal link behavior.
        */
        if (!submenu) return;

        event.preventDefault();
        event.stopPropagation();

        const isOpen =
          currentItem.classList.contains(
            'is-open'
          );

        drawer
          .querySelectorAll(
            '.bh-header__menu-item.is-open'
          )
          .forEach(item => {
            if (item === currentItem) return;

            item.classList.remove(
              'is-open'
            );

            const otherButton =
              item.querySelector(
                ':scope > .bh-header__menu-button'
              );

            if (otherButton) {
              otherButton.setAttribute(
                'aria-expanded',
                'false'
              );
            }
          });

        currentItem.classList.toggle(
          'is-open',
          !isOpen
        );

        button.setAttribute(
          'aria-expanded',
          String(!isOpen)
        );
      }
    );
  });
});